class Uploader {

    loadUploaderContent(token) {
        var data = new FormData();
        data.append("action", "loadUploaderContent");
        data.append("nextToken", token);
        data.append("uploaderNonce", uploaderObject.uploaderNonce);
        var ajax = new AjaxForm(data);
        ajax.call(function (d) {
            if (d.success) {
                $("#uploaderMain").append(d.message.html);
                $("#loadContentButton").attr("data-token", d.message.token);
            }
        });
    }

    submitUploadForm(htmlForm) {
        $("#form-message").hide().removeClass("alert-danger").removeClass("alert-success");
        var data = new FormData(htmlForm);
        data.append("action", "submitUpload");
        data.append("uploaderNonce", uploaderObject.uploaderNonce);
        var ajax = new AjaxForm(data);
        ajax.call(function (d) {
            $("#form-message").addClass("alert-success").show().text(d.message);
            location.reload();
        });
    }

    deleteFile(filename) {
        var data = new FormData();
        data.append("action", "deleteFile");
        data.append("uploaderNonce", uploaderObject.uploaderNonce);
        data.append("filename", filename);
        var ajax = new AjaxForm(data);
        ajax.call(function (d) {
            $("#form-message").addClass("alert-success").show().text(d.message);
            location.reload();
        });
    }

}

var uploader = new Uploader();
jQuery(document).ready(function ($) {

    $(document).on("mouseenter", ".click-copy", function () {
        $(this).css("opacity", "0.75");
    }).on("mouseleave", ".click-copy", function () {
        $(this).css("opacity", "0");
    });

    $(document).on("click", ".click-copy", function () {
        var _this = this;
        navigator.clipboard.writeText($(_this).attr("data-copy")).then(() => {
            var originalText = $(_this).text();
            var label = $(_this).find(".copy-label");
            label.text("Copied!");
            setTimeout(() => label.text(originalText), 1000);
        })
    });

    $("#uploadWindow").on("dragenter dragover", function (e) {
        e.preventDefault();
        e.stopPropagation();
        $("#uploadWindow").removeClass("bg-light").addClass("bg-secondary");
    });

    $("#uploadWindow").on("dragleave drop", function (e) {
        e.preventDefault();
        e.stopPropagation();
        $("#uploadWindow").removeClass("bg-secondary").addClass("bg-light");
    });

    $("#uploadWindow").on("drop", function (e) {
        e.preventDefault();
        const files = e.originalEvent.dataTransfer.files;
        if (files.length > 0) {
            $("#filedata").prop("files", files); // Assign dropped files to the input
        }
        $("#uploadForm").submit();
    });

    $("#uploadForm").on("submit", function (e) {
        e.preventDefault();
        uploader.submitUploadForm(this);
    });

    $("#loadContentButton").on("click", function () {
        let token = $(this).attr("data-token");
        uploader.loadUploaderContent(token);
    });
    $(document).on("click", ".deleteFile", function (e) {
        e.preventDefault();
        let filename = $(this).attr("data-filename");
        $(this).prop("disabled", true);
        uploader.deleteFile(filename);
    });
    $("#loadContentButton").click();

});


